var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"highlight-match"},_vm._l((_vm.parts),function(part,index){return _c('span',{key:index,class:{ 'highlight-match--hit': _vm.is_match(part) }},[_vm._v(_vm._s(part))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }